import { HttpContextToken } from '@angular/common/http';

export const NOTES_BAA_SIGN_REQUEST_TOKEN = new HttpContextToken<string | null>(() => null);
